import { useGetUploadFileListWithFilterCondition } from "@/features/renew-visa/hook/useGetUploadFileListWithFilterCondition";
import { validator } from "@/utils/validator";

export const useGetRenewVisaUploadFileSchema = () => {
  const { filterConditionArrayKeys } = useGetUploadFileListWithFilterCondition();

  const renewVisaUploadFileSchema = validator.object().shape({
    applicantListFilePath: validator.string().trim().emptyToNull().notRequired(),
    applicantIndividualResidentTaxCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    applicantIndividualResidentTaxCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    applicantResidentTaxPaymentCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    applicantResidentTaxPaymentCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    applicantWithholdingSlipCopyFilePath: validator.string().trim().emptyToNull().notRequired(),
    applicantWithholdingSlipCopyInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    applicantHealthInsuranceCardCopyFilePath: validator.string().trim().emptyToNull().notRequired(),
    applicantHealthInsuranceCardCopyInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    applicantHealthInsuranceRecordInquiryResponseFilePath: validator.string().trim().emptyToNull().notRequired(),
    applicantHealthInsuranceRecordInquiryResponseInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    applicantHealthInsurancePaymentCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    applicantHealthInsurancePaymentCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    applicantPensionReceiptCopy1FilePath: validator.string().trim().emptyToNull().notRequired(),
    applicantPensionReceiptCopy1Input: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    applicantPensionRecordInquiry2FilePath: validator.string().trim().emptyToNull().notRequired(),
    applicantPensionRecordInquiry2Input: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    previousApplicationDocumentsFilePath: validator.string().trim().emptyToNull().notRequired(),
    publicDutyPledgeFilePath: validator.string().trim().emptyToNull().notRequired(),
    publicDutyComplianceFilePath: validator.string().trim().emptyToNull().notRequired(),
    immigrationElectronicSystemPledgeFilePath: validator.string().trim().emptyToNull().notRequired(),
    documentOmissionPledgeFilePath: validator.string().trim().emptyToNull().notRequired(),
    foreignWorkerCompensationStatementFilePaths: validator.array().notRequired(),
    foreignWorkerCompensationStatementInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    isExistEmploymentContractCopyFilePath: validator.boolean().notRequired(),
    employmentContractCopyFilePath: validator
      .string()
      .trim()
      .emptyToNull()
      .notRequired()
      .when("isExistEmploymentContractCopyFilePath", {
        is: (value: boolean) => !value && filterConditionArrayKeys.includes("employmentContractCopyFilePath"),
        then: (schema) => schema.required("ファイルを選択してください。"),
      }),
    isExistEmploymentConditionsCopyFilePaths: validator.boolean().notRequired(),
    employmentConditionsCopyFilePaths: validator
      .array()
      .notRequired()
      .when("isExistEmploymentConditionsCopyFilePaths", {
        is: (value: boolean) => !value && filterConditionArrayKeys.includes("employmentConditionsCopyFilePaths"),
        then: (schema) => schema.min(1, "ファイルを選択してください。").required("ファイルを選択してください。"),
      }),
    isExistWagePaymentFilePath: validator.boolean().notRequired(),
    wagePaymentFilePath: validator
      .string()
      .trim()
      .emptyToNull()
      .notRequired()
      .when("isExistWagePaymentFilePath", {
        is: (value: boolean) => !value && filterConditionArrayKeys.includes("wagePaymentFilePath"),
        then: (schema) => schema.required("ファイルを選択してください。"),
      }),
    quarterlyReportCopyFilePath: validator.string().trim().emptyToNull().notRequired(),
    innovationCompanyProofFilePath: validator.string().trim().emptyToNull().notRequired(),
    certifiedCompanyProofFilePath: validator.string().trim().emptyToNull().notRequired(),
    annualSalaryReportCopyFilePath: validator.string().trim().emptyToNull().notRequired(),
    careWorkplaceOverviewFilePath: validator
      .string()
      .trim()
      .emptyToNull()
      .notRequired()
      .when([], {
        is: () => filterConditionArrayKeys.includes("careWorkplaceOverviewFilePath"),
        then: (schema) => schema.required("ファイルを選択してください。"),
      }),
    annualCalendarWithLanguageFilePath: validator.string().trim().emptyToNull().notRequired(),
    annualVariableWorkAgreementFilePath: validator.string().trim().emptyToNull().notRequired(),
    councilMembershipCertFilePath: validator
      .string()
      .trim()
      .emptyToNull()
      .notRequired()
      .when([], {
        is: () => filterConditionArrayKeys.includes("councilMembershipCertFilePath"),
        then: (schema) => schema.required("ファイルを選択してください。"),
      }),
    specifiedSkillAutomobileMaintenanceCertFilePath: validator
      .string()
      .trim()
      .emptyToNull()
      .notRequired()
      .test((value, ctx) => {
        if (
          filterConditionArrayKeys.includes("specifiedSkillAutomobileMaintenanceCertFilePath") &&
          !ctx.parent.specifiedSkillAutomobileMaintenanceCertFilePath &&
          !ctx.parent.specifiedSkillAutomobileMaintenanceIssuranceFilePath
        )
          return ctx.createError({ message: "ファイルを選択してください。" });
        return true;
      }),
    specifiedSkillAutomobileMaintenanceIssuranceFilePath: validator
      .string()
      .trim()
      .emptyToNull()
      .notRequired()
      .test((value, ctx) => {
        if (
          filterConditionArrayKeys.includes("specifiedSkillAutomobileMaintenanceIssuranceFilePath") &&
          !ctx.parent.specifiedSkillAutomobileMaintenanceCertFilePath &&
          !ctx.parent.specifiedSkillAutomobileMaintenanceIssuranceFilePath
        )
          return ctx.createError({ message: "ファイルを選択してください。" });
        return true;
      }),
    specificSkillOrganizationOverviewFilePath: validator.string().trim().emptyToNull().notRequired(),
    specificSkillOrganizationOverviewInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    hotelBusinessLicenseFilePath: validator.string().trim().emptyToNull().notRequired(),
    hotelBusinessLicenseInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    buildingEnvHealthMgmtRegistrationCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    buildingEnvHealthMgmtRegistrationCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    registeredCorporateStructureListPrintedFilePath: validator
      .string()
      .trim()
      .emptyToNull()
      .notRequired()
      .when([], {
        is: () => filterConditionArrayKeys.includes("registeredCorporateStructureListPrintedFilePath"),
        then: (schema) => schema.required("ファイルを選択してください。"),
      }),
    specificSkillsInstitutionOverviewDocumentFilePath: validator.string().trim().emptyToNull().notRequired(),
    specificSkillsInstitutionOverviewDocumentInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    registrationCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    registrationCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    executiveResidentRecordCopyFilePath: validator.string().trim().emptyToNull().notRequired(),
    executiveResidentRecordCopyInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    specificSkillsInstitutionOfficerAffidavitFilePath: validator.string().trim().emptyToNull().notRequired(),
    specificSkillsInstitutionOfficerAffidavitInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    individualBusinessOwnerResidentCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    individualBusinessOwnerResidentCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    specifiedSkillForeignWorkerPledgeFilePath: validator.string().trim().emptyToNull().notRequired(),
    specifiedSkillForeignWorkerPledgeInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    constructionSpecifiedSkillAcceptancePlanCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    constructionSpecifiedSkillAcceptancePlanCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    shipbuildingIndustryConfirmationFilePath: validator.string().trim().emptyToNull().notRequired(),
    shipbuildingIndustryConfirmationInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    ryokanBusinessLicenseFilePath: validator.string().trim().emptyToNull().notRequired(),
    ryokanBusinessLicenseInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    adultEntertainmentBusinessLicenseFilePath: validator.string().trim().emptyToNull().notRequired(),
    adultEntertainmentBusinessLicenseInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    businessLicenseOrNotificationFormFilePath: validator.string().trim().emptyToNull().notRequired(),
    businessLicenseOrNotificationFormInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    fishingLicenseCopy1FilePath: validator.string().trim().emptyToNull().notRequired(),
    fishingLicenseCopy1Input: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    fishingLicenseCopy2FilePath: validator.string().trim().emptyToNull().notRequired(),
    fishingLicenseCopy2Input: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    fishingLicenseCopy3FilePath: validator.string().trim().emptyToNull().notRequired(),
    fishingLicenseCopy3Input: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    fishingCooperativeRightsDocumentFilePath: validator.string().trim().emptyToNull().notRequired(),
    fishingCooperativeRightsDocumentInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    fishingCooperativeMembershipDocumentFilePath: validator.string().trim().emptyToNull().notRequired(),
    fishingCooperativeMembershipDocumentInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    fishingBoatRegistryCopyFilePath: validator.string().trim().emptyToNull().notRequired(),
    fishingBoatRegistryCopyInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    fishingBoatRegistrationCertCopyFilePath: validator.string().trim().emptyToNull().notRequired(),
    fishingBoatRegistrationCertCopyInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    laborInsuranceNoDelegationFilePath: validator.string().trim().emptyToNull().notRequired(),
    laborInsuranceNoDelegationInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    laborInsuranceDelegationFilePath: validator.string().trim().emptyToNull().notRequired(),
    laborInsuranceDelegationInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    socialInsurancePaymentStatusCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    socialInsurancePaymentStatusCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    healthInsuranceWelfarePensionCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    healthInsuranceWelfarePensionCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    nonHealthInsuranceWelfarePensionCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    nonHealthInsuranceWelfarePensionCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    individualHealthInsurancePaymentCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    individualHealthInsurancePaymentCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    individualPensionReceiptCopyFilePath: validator.string().trim().emptyToNull().notRequired(),
    individualPensionReceiptCopyInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    taxOfficePaymentCertNo3FilePath: validator.string().trim().emptyToNull().notRequired(),
    taxOfficePaymentCertNo3Input: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    corporateResidentTaxPaymentCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    corporateResidentTaxPaymentCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
    individualBusinessOwnerTaxOfficePaymentCertNo3FilePath: validator.string().trim().emptyToNull().notRequired(),
    individualBusinessOwnerTaxOfficePaymentCertNo3Input: validator
      .string()
      .trim()
      .emptyToNull()
      .label("提出確認欄：申請日及び申請番号")
      .notRequired(),
    individualResidentTaxCertFilePath: validator.string().trim().emptyToNull().notRequired(),
    individualResidentTaxCertInput: validator.string().trim().emptyToNull().label("提出確認欄：申請日及び申請番号").notRequired(),
  });

  //draft schema
  const renewVisaUploadFileDraftSchema = validator.object().shape({
    applicantListFilePath: validator.string().trim().emptyToNull().nullable(),
    applicantIndividualResidentTaxCertFilePath: validator.string().trim().emptyToNull().nullable(),
    applicantIndividualResidentTaxCertInput: validator.string().trim().emptyToNull().nullable(),
    applicantResidentTaxPaymentCertFilePath: validator.string().trim().emptyToNull().nullable(),
    applicantResidentTaxPaymentCertInput: validator.string().trim().emptyToNull().nullable(),
    applicantWithholdingSlipCopyFilePath: validator.string().trim().emptyToNull().nullable(),
    applicantWithholdingSlipCopyInput: validator.string().trim().emptyToNull().nullable(),
    applicantHealthInsuranceCardCopyFilePath: validator.string().trim().emptyToNull().nullable(),
    applicantHealthInsuranceCardCopyInput: validator.string().trim().emptyToNull().nullable(),
    applicantHealthInsuranceRecordInquiryResponseFilePath: validator.string().trim().emptyToNull().nullable(),
    applicantHealthInsuranceRecordInquiryResponseInput: validator.string().trim().emptyToNull().nullable(),
    applicantHealthInsurancePaymentCertFilePath: validator.string().trim().emptyToNull().nullable(),
    applicantHealthInsurancePaymentCertInput: validator.string().trim().emptyToNull().nullable(),
    applicantPensionReceiptCopy1FilePath: validator.string().trim().emptyToNull().nullable(),
    applicantPensionReceiptCopy1Input: validator.string().trim().emptyToNull().nullable(),
    applicantPensionRecordInquiry2FilePath: validator.string().trim().emptyToNull().nullable(),
    applicantPensionRecordInquiry2Input: validator.string().trim().emptyToNull().nullable(),
    previousApplicationDocumentsFilePath: validator.string().trim().emptyToNull().nullable(),
    publicDutyPledgeFilePath: validator.string().trim().emptyToNull().nullable(),
    publicDutyComplianceFilePath: validator.string().trim().emptyToNull().nullable(),
    immigrationElectronicSystemPledgeFilePath: validator.string().trim().emptyToNull().nullable(),
    documentOmissionPledgeFilePath: validator.string().trim().emptyToNull().nullable(),
    foreignWorkerCompensationStatementFilePaths: validator.array().nullable(),
    foreignWorkerCompensationStatementInput: validator.string().trim().emptyToNull().nullable(),
    employmentContractCopyFilePath: validator.string().trim().emptyToNull().nullable(),
    isExistEmploymentContractCopyFilePath: validator.boolean().nullable(),
    employmentConditionsCopyFilePaths: validator.array().nullable(),
    isExistEmploymentConditionsCopyFilePaths: validator.boolean().nullable(),
    wagePaymentFilePath: validator.string().trim().emptyToNull().nullable(),
    isExistWagePaymentFilePath: validator.boolean().nullable(),
    quarterlyReportCopyFilePath: validator.string().trim().emptyToNull().nullable(),
    innovationCompanyProofFilePath: validator.string().trim().emptyToNull().nullable(),
    certifiedCompanyProofFilePath: validator.string().trim().emptyToNull().nullable(),
    annualSalaryReportCopyFilePath: validator.string().trim().emptyToNull().nullable(),
    careWorkplaceOverviewFilePath: validator.string().trim().emptyToNull().nullable(),
    annualCalendarWithLanguageFilePath: validator.string().trim().emptyToNull().nullable(),
    annualVariableWorkAgreementFilePath: validator.string().trim().emptyToNull().nullable(),
    councilMembershipCertFilePath: validator.string().trim().emptyToNull().nullable(),
    specifiedSkillAutomobileMaintenanceCertFilePath: validator.string().trim().emptyToNull().nullable(),
    specifiedSkillAutomobileMaintenanceIssuranceFilePath: validator.string().trim().emptyToNull().nullable(),
    hotelBusinessLicenseFilePath: validator.string().trim().emptyToNull().nullable(),
    hotelBusinessLicenseInput: validator.string().trim().emptyToNull().nullable(),
    specificSkillOrganizationOverviewFilePath: validator.string().trim().emptyToNull().nullable(),
    specificSkillOrganizationOverviewInput: validator.string().trim().emptyToNull().nullable(),
    buildingEnvHealthMgmtRegistrationCertFilePath: validator.string().trim().emptyToNull().nullable(),
    buildingEnvHealthMgmtRegistrationCertInput: validator.string().trim().emptyToNull().nullable(),
    registeredCorporateStructureListPrintedFilePath: validator.string().trim().emptyToNull().nullable(),
    specificSkillsInstitutionOverviewDocumentFilePath: validator.string().trim().emptyToNull().nullable(),
    specificSkillsInstitutionOverviewDocumentInput: validator.string().trim().emptyToNull().nullable(),
    registrationCertFilePath: validator.string().trim().emptyToNull().nullable(),
    registrationCertInput: validator.string().trim().emptyToNull().nullable(),
    executiveResidentRecordCopyFilePath: validator.string().trim().emptyToNull().nullable(),
    executiveResidentRecordCopyInput: validator.string().trim().emptyToNull().nullable(),
    specificSkillsInstitutionOfficerAffidavitFilePath: validator.string().trim().emptyToNull().nullable(),
    specificSkillsInstitutionOfficerAffidavitInput: validator.string().trim().emptyToNull().nullable(),
    individualBusinessOwnerResidentCertFilePath: validator.string().trim().emptyToNull().nullable(),
    individualBusinessOwnerResidentCertInput: validator.string().trim().emptyToNull().nullable(),
    specifiedSkillForeignWorkerPledgeFilePath: validator.string().trim().emptyToNull().nullable(),
    specifiedSkillForeignWorkerPledgeInput: validator.string().trim().emptyToNull().nullable(),
    constructionSpecifiedSkillAcceptancePlanCertFilePath: validator.string().trim().emptyToNull().nullable(),
    constructionSpecifiedSkillAcceptancePlanCertInput: validator.string().trim().emptyToNull().nullable(),
    shipbuildingIndustryConfirmationFilePath: validator.string().trim().emptyToNull().nullable(),
    shipbuildingIndustryConfirmationInput: validator.string().trim().emptyToNull().nullable(),
    ryokanBusinessLicenseFilePath: validator.string().trim().emptyToNull().nullable(),
    ryokanBusinessLicenseInput: validator.string().trim().emptyToNull().nullable(),
    adultEntertainmentBusinessLicenseFilePath: validator.string().trim().emptyToNull().nullable(),
    adultEntertainmentBusinessLicenseInput: validator.string().trim().emptyToNull().nullable(),
    businessLicenseOrNotificationFormFilePath: validator.string().trim().emptyToNull().nullable(),
    businessLicenseOrNotificationFormInput: validator.string().trim().emptyToNull().nullable(),
    fishingLicenseCopy1FilePath: validator.string().trim().emptyToNull().nullable(),
    fishingLicenseCopy1Input: validator.string().trim().emptyToNull().nullable(),
    fishingLicenseCopy2FilePath: validator.string().trim().emptyToNull().nullable(),
    fishingLicenseCopy2Input: validator.string().trim().emptyToNull().nullable(),
    fishingLicenseCopy3FilePath: validator.string().trim().emptyToNull().nullable(),
    fishingLicenseCopy3Input: validator.string().trim().emptyToNull().nullable(),
    fishingCooperativeRightsDocumentFilePath: validator.string().trim().emptyToNull().nullable(),
    fishingCooperativeRightsDocumentInput: validator.string().trim().emptyToNull().nullable(),
    fishingCooperativeMembershipDocumentFilePath: validator.string().trim().emptyToNull().nullable(),
    fishingCooperativeMembershipDocumentInput: validator.string().trim().emptyToNull().nullable(),
    fishingBoatRegistryCopyFilePath: validator.string().trim().emptyToNull().nullable(),
    fishingBoatRegistryCopyInput: validator.string().trim().emptyToNull().nullable(),
    fishingBoatRegistrationCertCopyFilePath: validator.string().trim().emptyToNull().nullable(),
    fishingBoatRegistrationCertCopyInput: validator.string().trim().emptyToNull().nullable(),
    laborInsuranceNoDelegationFilePath: validator.string().trim().emptyToNull().nullable(),
    laborInsuranceNoDelegationInput: validator.string().trim().emptyToNull().nullable(),
    laborInsuranceDelegationFilePath: validator.string().trim().emptyToNull().nullable(),
    laborInsuranceDelegationInput: validator.string().trim().emptyToNull().nullable(),
    socialInsurancePaymentStatusCertFilePath: validator.string().trim().emptyToNull().nullable(),
    socialInsurancePaymentStatusCertInput: validator.string().trim().emptyToNull().nullable(),
    healthInsuranceWelfarePensionCertFilePath: validator.string().trim().emptyToNull().nullable(),
    healthInsuranceWelfarePensionCertInput: validator.string().trim().emptyToNull().nullable(),
    nonHealthInsuranceWelfarePensionCertFilePath: validator.string().trim().emptyToNull().nullable(),
    nonHealthInsuranceWelfarePensionCertInput: validator.string().trim().emptyToNull().nullable(),
    individualHealthInsurancePaymentCertFilePath: validator.string().trim().emptyToNull().nullable(),
    individualHealthInsurancePaymentCertInput: validator.string().trim().emptyToNull().nullable(),
    individualPensionReceiptCopyFilePath: validator.string().trim().emptyToNull().nullable(),
    individualPensionReceiptCopyInput: validator.string().trim().emptyToNull().nullable(),
    taxOfficePaymentCertNo3FilePath: validator.string().trim().emptyToNull().nullable(),
    taxOfficePaymentCertNo3Input: validator.string().trim().emptyToNull().nullable(),
    corporateResidentTaxPaymentCertFilePath: validator.string().trim().emptyToNull().nullable(),
    corporateResidentTaxPaymentCertInput: validator.string().trim().emptyToNull().nullable(),
    individualBusinessOwnerTaxOfficePaymentCertNo3FilePath: validator.string().trim().emptyToNull().nullable(),
    individualBusinessOwnerTaxOfficePaymentCertNo3Input: validator.string().trim().emptyToNull().nullable(),
    individualResidentTaxCertFilePath: validator.string().trim().emptyToNull().nullable(),
    individualResidentTaxCertInput: validator.string().trim().emptyToNull().nullable(),
  });

  return { renewVisaUploadFileSchema, renewVisaUploadFileDraftSchema };
};
